var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "doc-ok",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.946,
    height: 34.17,
    viewBox: "0 0 32.946 34.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14476",
    "data-name": "Grupo 14476",
    transform: "translate(-919.054 -309.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search-alt",
    d: "M20.811,8.062a1.344,1.344,0,0,1,0,2.687H10.062a1.344,1.344,0,0,1,0-2.687ZM16.78,29.56H8.718a4.031,4.031,0,0,1-4.031-4.031V6.718A4.031,4.031,0,0,1,8.718,2.687H24.842a1.344,1.344,0,0,1,1.344,1.344V14.78a1.344,1.344,0,1,0,2.687,0V4.031A4.031,4.031,0,0,0,24.842,0H8.718A6.726,6.726,0,0,0,2,6.718V25.529a6.726,6.726,0,0,0,6.718,6.718H16.78a1.344,1.344,0,0,0,0-2.687Z",
    transform: "translate(917.054 309.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search-alt-2",
    "data-name": "search-alt",
    d: "M20,7.091a1.344,1.344,0,0,1,0,2.687H9.253a1.344,1.344,0,0,1,0-2.687Z",
    transform: "translate(917.863 315.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search-alt-3",
    "data-name": "search-alt",
    d: "M20,7.091a1.344,1.344,0,0,1,0,2.687H9.253a1.344,1.344,0,0,1,0-2.687Z",
    transform: "translate(917.863 319.896)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14477",
    "data-name": "Grupo 14477",
    transform: "translate(-919.054 -183.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(938 204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0ZM7,0",
    fill: "#00e52e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M145.423,165.938l-2.323,2.323a.357.357,0,0,1-.505,0l-1.162-1.162a.357.357,0,1,1,.505-.505l.909.909,2.071-2.071a.357.357,0,0,1,.505.505Zm0,0",
    transform: "translate(-136.064 -159.407)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocOk);
export default __webpack_public_path__ + "static/media/doc-ok.5c940d1cbe81a38acace8d8cb51ee297.svg";
export { ForwardRef as ReactComponent };